import { Outlet, useParams } from "react-router-dom";
import PomoCustomer from "./PromotionCustomer/Promo";

const Tab6 = ({ routeBase = "/customer/promotions" }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PomoCustomer routeBase={routeBase} />;
};

export default Tab6;
